import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { Box, Typography } from '@mui/material'
import { getConfiguration, getSuperAdminOrderDetail } from '../../apollo'
import CustomLoader from '../Loader/CustomLoader'
import OrderDetailView from './OrderDetailView'
import OrderRefunds, { canRecordRefunds } from './OrderRefunds'

const GET_CONFIGURATION = gql`
  ${getConfiguration}
`

const GET_SUPER_ADMIN_ORDER_DETAIL = gql`
  ${getSuperAdminOrderDetail}
`

const shellSx = {
  bgcolor: '#FFFFFF',
  borderRadius: '18px',
  p: 4,
  display: 'flex',
  justifyContent: 'center'
}

function SuperAdminOrder({ order, onClose }) {
  const { data: configurationData } = useQuery(GET_CONFIGURATION)
  const { data: orderData, loading, error } = useQuery(
    GET_SUPER_ADMIN_ORDER_DETAIL,
    {
      variables: { id: order?._id },
      skip: !order?._id,
      fetchPolicy: 'cache-and-network'
    }
  )

  if (!order) return null

  const orderDetails = orderData?.order

  if (loading && !orderDetails) {
    return (
      <Box sx={shellSx}>
        <CustomLoader />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={shellSx}>
        <Typography sx={{ color: 'error.main' }}>{error.message}</Typography>
      </Box>
    )
  }

  if (!orderDetails) return null

  const orderId = orderDetails.orderId || order.orderId
  const currency = configurationData?.configuration?.currencySymbol || ''

  // The list row already carries the id, status and customer; the detail
  // query fills in items, charges and addresses.
  return (
    <OrderDetailView
      order={{
        ...order,
        ...orderDetails,
        orderId,
        user: orderDetails.user || order.user
      }}
      currency={currency}
      onClose={onClose}
      footer={
        canRecordRefunds() ? (
          <OrderRefunds orderId={orderId} currency={currency} />
        ) : null
      }
    />
  )
}

export default SuperAdminOrder
